import React from 'react';
import styled from 'styled-components';

const Description = styled.div`
    img {
        max-width: 100%;
        height: auto;
    }
`;

const DescriptionWithHTML = ({ data }) => {
    return (
        <Description dangerouslySetInnerHTML={{ __html: data }} />
    );
};

export default DescriptionWithHTML;
